import { ProductOption } from '../../shared/models/product-option.model';
import { FormOptions } from './base.form-options';

export class SelectProductFormOptions extends FormOptions {
  products: ProductOption[] = [];
}
